import { createContext } from 'react'
import noop from 'lib/function/noop'
import type { DevPanelAction } from './types'

export const DevPanelDispatchContext = createContext<(action: DevPanelAction) => void>(noop)
